import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../../helpers/value'
import { COMPONENTS } from '../../../../routers/constants'
import {
  changeCheckboxTable,
  getDataTableByRowId,
  selectCheckboxFilter,
} from '../../../filteredCompanies/filteredCompany/store/slice'

export const CustomTdTitle = ({ val, rowId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(getDataTableByRowId(rowId))
  const isCheck = useSelector(selectCheckboxFilter(['listIdsSelected', rowId]))
  const listCheckbox = useSelector(selectCheckboxFilter(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)

  const handleCheckbox = (value) => {
    dispatch(
      changeCheckboxTable({
        path: ['listIdsSelected', rowId],
        data: value,
      }),
    )
  }

  return (
    <>
      <Element
        className={['dFlex alignItemsCenter'].join(' ')}
        onClick={() => {
          if (!isCanNavigate) {
            handleCheckbox(!isCheck)
          }
        }}
        style={{ padding: '4px 12px' }}
      >
        <div style={{ paddingRight: 26 }}>
          <Checkbox
            styleIcon={{ fontSize: 13 }}
            onChange={handleCheckbox}
            checked={isCheck}
          />
        </div>
        {isCanNavigate ? (
          <Element
            elementName="a"
            href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${dataRow?.organizationId}`}
            target="_blank"
            style={{ color: '#2C73E8' }}
          >
            <TextEllipsisStaticLine
              text={formatText(val)}
              lineClamp={2}
              tooltipStyle={{ minWidth: 200 }}
              isI18n={false}
            />
          </Element>
        ) : (
          <TextEllipsisStaticLine
            text={formatText(val)}
            lineClamp={2}
            tooltipStyle={{ minWidth: 200 }}
            isI18n={false}
            appendStyle={{ cursor: 'pointer', color: '#2C73E8' }}
          />
        )}
      </Element>
    </>
  )
}
